import { ajax } from '@utils/http';
import { getAppId } from '@utils/global';
import { getQueryString } from '@utils/tools';

// 配置页面微信接口
export function configWxSDK(){
  ajax({
    url: '/index.php?r=AppConfig/GetSmartyVar',
    type: 'get',
    data: {
      app_id: getQueryString('app_id') || getAppId(),
    },
    success: function(res){
      var is_custom_domain = res.data.is_custom_domain;
      var url = WX_SDK_DOMAIN; // 配置的全局常量 webpack.definePlugin webpack.cofig.js/webpack.prod.js中修改
      if(is_custom_domain == '1'){
        url  = '//gzh.zhichiwangluo.com';
      }
      ajax({
        url : url + '/index.php?r=Share/appJsConfig',
        type: 'get',
        data: {
          app_id: getQueryString('app_id') || getAppId(),
        },
        success: function(data){
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature,// 必填，签名，见附录1
            jsApiList: ['updateAppMessageShareData','updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareQZone', 'startRecord' ,'stopRecord' ,'onVoiceRecordEnd' ,'playVoice','pauseVoice', 'stopVoice' ,'onVoicePlayEnd' , 'uploadVoice' , 'downloadVoice' , 'chooseImage','previewImage' , 'uploadImage','downloadImage','translateVoice', 'openLocation', 'getLocation', 'scanQRCode', 'chooseWXPay', 'addCard', 'chooseCard', 'openCard', 'openProductSpecificView', 'hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems', 'closeWindow', 'openAddress', 'onMenuShareAppMessage', 'onMenuShareQQ'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            fail: function(msg){
              console.log(msg);
            }
          });
        }
      });
    }
  })
};
//微信分享设置
export function configWxShare(data){
  console.log(JSON.stringify(data));
  wx.ready(function(){
    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容, 需在用户可能点击分享按钮前就先调用

    let shareOptions = {
      title: data.title, // 分享标题
      desc: data.desc || '', // 分享描述
      link: data.link, // 分享链接
      imgUrl: data.imgUrl || '', // 分享图标
      success: function (msg) {
        // 设置成功
        // alert('11' + JSON.stringify(msg))
        console.log('设置分享朋友成功', JSON.stringify(msg));
        typeof data.success === 'function' && data.success(msg);
      },
      fail: function(msg){
        // alert('12' + JSON.stringify(msg))
        console.log('设置分享朋友失败', JSON.stringify(msg));
        typeof data.fail === 'function' && data.fail(msg);
      },
      trigger: function(msg){
        // alert('13' + JSON.stringify(msg))
        console.log('点击分享朋友触发事件', JSON.stringify(msg));
      }
    };

    // wx.updateAppMessageShareData(shareOptions); 这个接口在某些机型上面有问题。先用下面两个接口替代，等后续再替换回来。
    wx.onMenuShareAppMessage(shareOptions);
    wx.onMenuShareQQ(shareOptions);


    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
    wx.updateTimelineShareData({ 
      title: data.title, // 分享标题
      link: data.link, // 分享链接
      imgUrl: data.imgUrl || '', // 分享图标
      success: function (msg) {
        // 设置成功
        typeof data.success === 'function' && data.success(msg);
      },
      fail: function(msg){
        typeof data.fail === 'function' && data.fail(msg);
      }
    })
  })
};


// WEBPACK FOOTER //
// ./src/utils/weixinSdkConfig.jsx